import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Welcome from './pages/Welcome';
import AdminLogs from './pages/AdminLogs';
import KarmaPage from './pages/KarmaPage';
import ChecklistPage from './pages/ChecklistPage';
import CalendarPage from './pages/CalendarPage';
import MessagesPage from './pages/MessagesPage';
import IntakeTrackerPage from './pages/IntakeTrackerPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/karma" element={<KarmaPage />} />
        <Route path="/checklist" element={<ChecklistPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/intake" element={<IntakeTrackerPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/admin/logs" element={<AdminLogs />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
